export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00054.652c397a.png";